import React, { useEffect, useState } from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import pic from "../images/pinnacle.png";
import pic2 from "../images/imagebook.png";
import "./Blog1.css"; // Ensure you have this CSS file
import { Link, useNavigate } from "react-router-dom";

const BlogHeader = () => {
  const navigate = useNavigate();
  const home = () => {
    navigate("/");
  };

  const blog = () => {
    navigate("/blog");
  };
  const portalHandler = () => {
    window.open("https://testportal.ssccglpinnacle.com", "_blank");
  };
  const booksHandler = () => {
    window.open("https://books.ssccglpinnacle.com", "_blank");
  };
  return (
    <>
      <header className="blog-header">
        <div className="nav-logo-wrapper-pinncale">
          <div className="nav-logo-img">
            <div className="blog-img-logo" onClick={home}>
              <img className="logo-blog" src={pic} alt="Pinnacle Logo" />
            </div>
          </div>
          <div className="for-blog-header">
            <p className="blog-para-header" onClick={blog}>
              Blog
            </p>
            <div className="header-buttons">
              <button className="btnnnn business-btn" onClick={portalHandler}>
                Pinnacle Test Portal
              </button>
              <button
                className="btnnnn courses-brod-btn"
                onClick={booksHandler}
              >
                Browse Pinnacle Books
              </button>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default BlogHeader;
